import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AppConfigProvider } from './contexts/AppConfigContext';
import { queryClient } from './lib/queryClient';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    // AppConfigProvider fetches the backend-configured display timezone once on app
    // bootstrap and exposes it via useDisplayTimezone(); see contexts/AppConfigContext.js.
    <QueryClientProvider client={queryClient}>
      <AppConfigProvider>
        <App />
      </AppConfigProvider>
    </QueryClientProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
